import React from "react";
import { Redirect, Route, RouteProps, useLocation } from "react-router-dom";
import { Spinner } from "@kui-react/spinner";
import { isPublicRoute } from "./isPublicRoute";
import { isLocalHost } from "server/kas/utils";
import { useKas } from "contexts/KasContext";
import {
  setPostLoginRedirect,
  shouldPersistPostLoginRedirect,
} from "utils/redirects";

const SecuredRoute: React.FC<RouteProps> = (props) => {
  const location = useLocation();

  const { isLoading, isUserLoggedIn, user } = useKas();

  if (isPublicRoute(location.pathname)) {
    return <Route {...props} />;
  }

  if (isLoading || isUserLoggedIn === undefined || (isUserLoggedIn && !user)) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner
          className="text-gray-700 dark:text-secondary"
          description="Loading"
        />
      </div>
    );
  }

  // TODO - for some reason on localhost
  // this code path gets triggered maybe 1 out
  // of 3 or 4 times when loading the app???
  // investigate after... but seems like it doesn't happen in prod
  if (!isUserLoggedIn && !isLocalHost) {
    if (shouldPersistPostLoginRedirect(location.pathname)) {
      setPostLoginRedirect(location.pathname + location.search);
    }
    return <Redirect to="/login" />;
  }
  if (isUserLoggedIn && user) {
    return <Route {...props} />;
  }
  return <Redirect to="/login" />;
};

export default SecuredRoute;
